
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1.0","viewBox":"0 0 38.35 39.97","shape-rendering":"geometricPrecision","text-rendering":"geometricPrecision","image-rendering":"optimizeQuality","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.71 4.02H14.6l2.16 3.41H3.42v29.13h29.13V22.24l3.41 3.63v14.11H.01V4.03h1.71zM34.94 17.8V4.95l-19.83 20-2.41-2.4L31.68 3.41H19.36V0h19v17.8h-3.41z","fill":"#2b2b2a","fill-rule":"nonzero"}})])
          )
        }
      }
    